import React from 'react';
import PropTypes from 'prop-types';
import callToActionData from 'core/data/call-to-action-data';
import { useInitialFetch } from 'core/context/initialFetchContext';

const CallToAction = ({ className }) => {
    const publicUrl = process.env.PUBLIC_URL || '';
    const { subtitle, title, phone, buttonText, contactText, images } = callToActionData;
    const { storeInformation } = useInitialFetch();
    const message = "Hola, estoy interesado en obtener más información."; // New message
    const whatsappUrl = `https://wa.me/${storeInformation?.whatsapp}?text=${encodeURIComponent(message)}`; // Updated URL

    return (
        <div
            className={`ltn__call-to-action-area ltn__call-to-action-4 pt-90 pb-120 ${className}`}
            style={{ backgroundImage: `url(${publicUrl + images.background})` }}
        >
            <div className="container text-center">
                <div className="call-to-action-inner call-to-action-inner-4">
                    <div className="section-title-area ltn__section-title-2">
                        <h6 className="section-subtitle ltn__secondary-color" style={{ color: '#333' }}>{subtitle}</h6>
                        <h1 className="section-title" style={{ color: '#333' }}>{title}</h1>
                    </div>
                    <div className="btn-wrapper d-flex justify-content-center gap-3 mt-3">
                        {/* <a href={`tel:${storeInformation?.phone_number}`} className="theme-btn-1 btn btn-effect-1">
                            LLAMANOS AHORA
                        </a> */}
                        <a
                            href={whatsappUrl} // Updated to use the new URL
                            className="btn theme-btn-4"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {contactText}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

CallToAction.propTypes = {
    className: PropTypes.string,
};

CallToAction.defaultProps = {
    className: 'section-bg-1',
};

export default CallToAction;